import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 5000 },
  };

  connect() {
    // Animación de entrada
    this.element.style.opacity = "0";
    this.element.style.transform = "translateY(-20px)";

    requestAnimationFrame(() => {
      this.element.style.opacity = "1";
      this.element.style.transform = "translateY(0)";
    });

    // Auto-dismiss después del delay
    this.timeout = setTimeout(() => {
      this.dismiss();
    }, this.delayValue);
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  dismiss() {
    // Animación de salida
    this.element.style.opacity = "0";
    this.element.style.transform = "translateY(-20px)";

    setTimeout(() => {
      this.element.remove();
    }, 300);
  }
}
